// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postDriver } from '../../services/DriversService';
import { Driver, PostDriverRequest } from '../../types/Drivers';

type Result = UseMutationResult<Driver, Error, PostDriverRequest>;

function usePostDriver(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postDriver, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['drivers'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostDriver;
